export default "__VITE_ASSET__D2aG$bSj__"